import { signOut as types } from '../actions/actiontypes'

interface SignOutState {
  ongoing: boolean
  status: string | undefined
  message: string
  result: 'unknown' | 'success' | 'failed'
}

interface SignOutAction {
  type: string
  status?: string
  message?: string
}

const initState: SignOutState = {
  ongoing: false,
  status: undefined,
  message: '',
  result: 'unknown',
}

export function signOutReducer(state: SignOutState = initState, action: SignOutAction): SignOutState {
  switch (action.type) {
    case "STORE_RESET":
      return Object.assign({}, initState)
    case types.REQUESTED:
      return Object.assign({}, state, {
        ongoing: true,
      })
    case types.SUCCESS:
      return Object.assign({}, state, {
        ongoing: false,
        result: 'success' as const
      })
    case types.FAILED:
      return Object.assign({}, state, {
        ongoing: false,
        status: action.status,
        message: action.message,
        result: 'failed' as const
      })
    default:
      return state
  }
}